$(document).ready(function () {
// цвет и сортировка-выпадайка на мобильном страница каталога
    $(".sort-btn").on('click', function (e) {
        $(".sorting").addClass('active');
    });
    $(".color_btn").on('click', function (e) {
        $(".color-menu").addClass('active');
    });
    $(document).on('mousedown touchstart', function (e) {
        var sort_menu = $(".sorting"),
            color_menu = $(".color-menu");
        if (!sort_menu.is(e.target) && sort_menu.has(e.target).length === 0) {
            sort_menu.removeClass('active');
        }
        if (!color_menu.is(e.target) && color_menu.has(e.target).length === 0) {
            color_menu.removeClass('active');
        }
    });
});